import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type BeneficiariesPendingSignatureTableFilterAlertProps = {
  isFiltered: boolean;
  filteredCount: number;
  totalBeneficiaries: number;
  onClearFilter: () => void;
};

const BeneficiariesPendingSignatureTableFilterAlert: FC<
  BeneficiariesPendingSignatureTableFilterAlertProps
> = ({ isFiltered, filteredCount, totalBeneficiaries, onClearFilter }) => {
  const { t } = useTranslate();

  if (!isFiltered) {
    return null;
  }

  return (
    <div className="card-header bg-light">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <em className="icon ni ni-filter text-dark mr-2" />
          <span className="text-muted">
            {t('showingFilteredResults')}: {filteredCount} {t('of')}{' '}
            {totalBeneficiaries} {t('beneficiaries')}
          </span>
        </div>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onClearFilter}
        >
          <em className="icon ni ni-cross me-1" />
          {t('clearFilter')}
        </button>
      </div>
    </div>
  );
};

export default BeneficiariesPendingSignatureTableFilterAlert;
